<template>
    <div>
        <button
            class="btn btn-outline-dark"
            @click="getAnnouncements();showAnn=!showAnn"
        >Manage Announcements</button>
        <br />
        <div v-if="showAnn">
            <br />
            <button class="btn btn-sm btn-outline-dark" @click="showAnnForm=!showAnnForm">Add announcement</button>
            <div v-if="showAnnForm">
                <br />
                <b-form-input v-model="annText" placeholder="Enter announcement text"></b-form-input>
                <br />
                <b-form-checkbox
                    v-model="annShow"
                >Show announcement</b-form-checkbox>
                <br />
                <button class="btn btn-sm btn-outline-success" @click="addAnn()">Submit</button>
            </div>
            <br />
            <br />
            <table class="table">
                <thead>
                    <tr>
                        <th>Announcement</th>
                        <th>Visibility</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="announcement in announcements" v-bind:key="announcement.text">
                        <td>{{announcement.text}}</td>
                        <td>
                            <b-form-checkbox
                                v-model="announcement.show"
                                @change="toggleShow(announcement)"
                            ></b-form-checkbox>
                        </td>
                        <td>
                            <button
                                class="btn btn-sm btn-outline-danger"
                                @click="deleteAnn(announcement)"
                            >Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
const fb = require('../../firebaseConfig')
export default {
    data() {
        return {
            showAnn: false,
            showAnnForm: false,
            announcements: [],
            annText: "",
            annShow: false,
        };
    },
    methods: {
        getAnnouncements() {
            if (this.announcements.length) {
                return;
            }
            this.process = true;
            fb.db
                .collection("announcements")
                .orderBy("timestamp", "desc")
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        this.announcements.push(doc.data());
                    });
                })
                .then(() => {
                    this.process = false;
                });
        },
        addAnn() {
            fb.db
                .collection("announcements")
                .add({
                    text: this.annText,
                    show: this.annShow,
                    timestamp: fb.firebase.firestore.FieldValue.serverTimestamp()
                })
                .then(docRef => {
                    fb.db
                        .collection("announcements")
                        .doc(docRef.id)
                        .get()
                        .then(doc => {
                            this.announcements.push(doc.data());
                            this.annText = "";
                            this.annShow = false;
                            this.showAnnForm = false;
                        });
                });
        },
        toggleShow(a) {
            fb.db
                .collection("announcements")
                .where("text", "==", a.text)
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        fb.db
                            .collection("announcements")
                            .doc(doc.id)
                            .update({
                                show: a.show
                            });
                    });
                });
        },
        deleteAnn(a) {
            fb.db
                .collection("announcements")
                .where("text", "==", a.text)
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        fb.db
                            .collection("announcements")
                            .doc(doc.id)
                            .delete()
                            .then(() => {
                                const index = this.announcements.indexOf(a);
                                this.announcements.splice(index, 1);
                            });
                    });
                });
        }
    }
};
</script>